<template>
	<DrawerPanel
		ref="drawer"
		title="WhatsApp AI Assistant"
		bottom="-18px"
		openHeight="80%"
		closedHeight="0px"
		:startOpened="false"
		:blurBackground="true"
		openBackgroundColor="white"
		:divider="false"
		:hideNavBar="true"
		@closed="handleClosed"
	>
		<div class="whatsapp-enable-content">
			<!-- Before Enable State -->
			<div v-if="state === 'initial'" class="whatsapp-initial-state">
				<img src="@/assets/EnableWhatapp.png" alt="WhatsApp" class="whatsapp-enable-image" />
				<h2 class="whatsapp-enable-heading">Your personal financial assistant</h2>
				<div class="whatsapp-features">
					<div class="whatsapp-feature-item">
						<img src="@/assets/reminders.png" alt="" class="feature-icon" />
						<span class="feature-text">Get reminders before your policies expire</span>
					</div>
					<div class="whatsapp-feature-item">
						<img src="@/assets/policies.png" alt="" class="feature-icon" />
						<span class="feature-text">Add policies with ease by sharing documents</span>
					</div>
					<div class="whatsapp-feature-item">
						<img src="@/assets/AI-Chat-24px.svg" alt="" class="feature-icon" />
						<span class="feature-text">Your queries answered in minutes</span>
					</div>
				</div>
				<MGButton
					text="Enable WhatsApp"
					:fullWidth="true"
					@click="handleEnable"
				/>
			</div>

			<!-- After Enable State -->
			<div v-else class="whatsapp-sent-state">
				<img src="@/assets/EnableWhatapp.png" alt="WhatsApp" class="whatsapp-enable-image-small" />
				<h2 class="whatsapp-enable-heading">We have sent you a WhatsApp message</h2>
				<div class="whatsapp-instructions">
					<p class="instruction-text">Once received, open the message and tap "I'm in".</p>
					<p class="instruction-text">Your AI assistant is available 24/7 for all your personal finance queries.</p>
					<p class="instruction-text-light">Tap resend below if your message doesn't arrive within a few minutes.</p>
				</div>
				<MGButton
					text="Done"
					:fullWidth="true"
					@click="handleDone"
				/>
				<MGButton
					text="Resend message"
					:fullWidth="true"
					:textOnly="true"
					:stacked="true"
					@click="handleResend"
				/>
			</div>
		</div>
	</DrawerPanel>
</template>

<script>
import DrawerPanel from './DrawerPanel.vue';
import MGButton from './MGButton.vue';

export default {
	name: 'WhatsAppEnableDrawer',
	components: {
		DrawerPanel,
		MGButton
	},
	data() {
		return {
			state: 'initial'
		}
	},
	emits: ['done', 'closed', 'enable'],
	methods: {
		openDrawer() {
			this.state = 'initial';
			this.$nextTick(() => {
				if (this.$refs.drawer) {
					this.$refs.drawer.openDrawer();
				}
			});
		},
		closeDrawer() {
			if (this.$refs.drawer) {
				this.$refs.drawer.closeDrawer();
			}
		},
		handleEnable() {
			this.$emit('enable');
			this.state = 'sent';
		},
		handleDone() {
			this.closeDrawer();
			this.$emit('done');
		},
		handleResend() {
			this.$emit('enable');
		},
		handleClosed() {
			this.state = 'initial';
			this.$emit('closed');
		}
	}
}
</script>

<style scoped>
.whatsapp-enable-content {
	padding: 0 20px 40px;
	max-width: 400px;
	margin: 0 auto;
}

.whatsapp-initial-state,
.whatsapp-sent-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
}

.whatsapp-enable-image {
	width: 153px;
	height: auto;
}

.whatsapp-enable-image-small {
	width: 73px;
	height: auto;
}

.whatsapp-enable-heading {
	font-size: 20px;
	font-weight: bold;
	text-align: center;
	color: var(--text-color);
	margin: 0;
}

.whatsapp-features {
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
}

.whatsapp-feature-item {
	display: flex;
	align-items: center;
	gap: 12px;
}

.feature-icon {
	width: 40px;
	height: 40px;
	flex-shrink: 0;
}

.feature-text {
	font-size: 15px;
	color: var(--text-color);
}

.whatsapp-instructions {
	display: flex;
	flex-direction: column;
	gap: 12px;
	text-align: left;
	width: 100%;
}

.instruction-text {
	font-size: 15px;
	line-height: 1.47;
	color: var(--text-color);
	margin: 0;
}

.instruction-text-light {
	font-size: 15px;
	line-height: 1.47;
	color: rgba(65, 54, 85, 0.5);
	margin: 0;
}

</style>
